module.exports = __webpack_public_path__ + "static/media/LYD-AVAX.0dc6ad92.png";